"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userPaymentDetailsController = function () {
  function userPaymentDetailsController(UsersService, AppContextService, NotificationService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, userPaymentDetailsController);
    this.usersService = UsersService;
    this.appContextService = AppContextService;
    this.notificationService = NotificationService;

    this.editMode = {
      walletBalance: {
        active: false,
        value: ""
      }
    };
  }

  (0, _createClass3.default)(userPaymentDetailsController, [{
    key: "enableEditMode",
    value: function enableEditMode(field) {
      this.editMode[field].active = true;

      this.editMode[field].value = this.user[field];
    }
  }, {
    key: "disableEditMode",
    value: function disableEditMode(field) {
      this.editMode[field].active = false;
      if (field == 'walletBalance') {
        var newBalance = parseInt(this.editMode[field].value);
        this.user[field] = newBalance;
      } else {
        this.user[field] = this.editMode[field].value;
      }
    }
  }, {
    key: "updateWalletBalance",
    value: function updateWalletBalance(field) {
      var _this = this;

      this.editMode[field].isLoading = true;
      this.usersService.updateWalletBalance(this.user.userId, this.user.walletBalance, function (response) {
        _this.editMode[field].isLoading = false;
        _this.editMode[field].active = false;
        _this.notificationService.success("Update Successful");
        _this.user = response.data;
      }, function (error) {
        _this.notificationService.error("Update Failed");
        _this.editMode[field].isLoading = false;
      });
    }
  }, {
    key: "getPaymentDeviceType",
    value: function getPaymentDeviceType(type) {
      if (!type) return "-";

      switch (type) {
        case _constants2.default.deviceType.DESKTOP:
          return "Desktop";
        case _constants2.default.deviceType.MOBILE:
          return "Mobile Web";
        case _constants2.default.deviceType.MOBILEAPP:
          return "Mobile App";
        default:
          return 'Unknown';
      }
    }
  }, {
    key: "getPaymentType",
    value: function getPaymentType(paymentType) {
      if (!paymentType) return "-";

      switch (paymentType) {
        case _constants2.default.userPaymentType.SINGLE_ONE_OFF_JOB:
          return 'One-off Job';
        case _constants2.default.userPaymentType.SINGLE_RECURRING_JOB:
          return 'Recurring Job';
        case _constants2.default.userPaymentType.SINGLE_AU_PAIR_JOB:
          return 'Au Pair Job';
        case _constants2.default.userPaymentType.SINGLE_PRIMARY_SCHOOL_TUTORING_JOB:
          return 'Primary School Tutoring Job';
        case _constants2.default.userPaymentType.SINGLE_HIGH_SCHOOL_TUTORING_JOB:
          return 'High School Tutoring Job';
        case _constants2.default.userPaymentType.ANNUAL_UNLIMITED_PAY_AS_YOU_GO:
          return '12 Months Unlimited Plan';
        case _constants2.default.userPaymentType.SIX_MONTHS_UNLIMITED_PAY_AS_YOU_GO:
          return '6 Months Unlimited Plan';
        case _constants2.default.userPaymentType.EXTEND_RECURRING_JOB:
          return 'Extend Recurring Job';
        case _constants2.default.userPaymentType.ANNUAL_BABYSITTING_SUBSCRIPTION60:
        case _constants2.default.userPaymentType.ANNUAL_BABYSITTING_SUBSCRIPTION120:
          return 'Babysitting Annual Subscription';
        case _constants2.default.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION120:
          return 'Complete Childminding Annual Subscription';
        case _constants2.default.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION90:
        case _constants2.default.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION195:
        case _constants2.default.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION245:
          return 'Tutoring Annual Subscription';
        case _constants2.default.userPaymentType.ANNUAL_PRIMARY_SCHOOL_TUTORING_SUBSCRIPTION120:
          return 'Primary School Tutoring Annual Subscription';
        case _constants2.default.userPaymentType.ANNUAL_HIGH_SCHOOL_TUTORING_SUBSCRIPTION195:
          return 'High School Tutoring Annual Subscription';
        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION:
        case _constants2.default.userPaymentType.ANNUAL_FOUNDING_MEMBER:
        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_120:
        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_150:
        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_180:
        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION_180:
        case _constants2.default.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION24:
        case _constants2.default.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION30:
        case _constants2.default.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION40:
        case _constants2.default.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION180:
        case _constants2.default.userPaymentType.ANNUAL_COMPLETE_FAMILY_CARE_SUBSCRIPTION120:
        case _constants2.default.userPaymentType.ANNUAL_HELPER_STANDARD_SUBSCRIPTION50:
          return 'Annual Subscription';
        case _constants2.default.userPaymentType.MONTHLY_HELPER_STANDARD_SUBSCRIPTION5:
          return 'Monthly Subscription';
        case _constants2.default.userPaymentType.MONTHLY_BABYSITTING_SUBSCRIPTION40:
        case _constants2.default.userPaymentType.MONTHLY_CHILDCARE_SUBSCRIPTION90:
        case _constants2.default.userPaymentType.MONTHLY_CHILDCARE_SUBSCRIPTION60:
          return 'Monthly Subscription';
        case _constants2.default.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION:
        case _constants2.default.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION_60:
        case _constants2.default.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION_75:
        case _constants2.default.userPaymentType.QUARTERLY_STANDARD_SUBSCRIPTION_90:
        case _constants2.default.userPaymentType.QUARTERLY_HELPER_SUBSCRIPTION15:
        case _constants2.default.userPaymentType.QUARTERLY_HELPER_SUBSCRIPTION20:
        case _constants2.default.userPaymentType.THREE_MONTHS_HELPER_STANDARD_SUBSCRIPTION25:
          return 'Quarterly Subscription';
        case _constants2.default.userPaymentType.ANNUAL_TUTORING_SUBSCRIPTION180:
          return 'Tutoring (In-home & Online)';
        case _constants2.default.userPaymentType.ANNUAL_FAMILY_CARE_SUBSCRIPTION240:
          return 'Complete Childcare & Tutoring';
        case _constants2.default.userPaymentType.ANNUAL_AU_PAIR_SUBSCRIPTION195:
          return 'Au Pair Annual Membership';
        case _constants2.default.userPaymentType.ANNUAL_STANDARD_SUBSCRIPTION360:
          return 'Au Pair Premium Membership';
        case _constants2.default.userPaymentType.QUARTERLY_BUSINESS_TIER1_SUBSCRIPTION_500:
          return 'Juggle St Pro - Single Site Quarterly';
        case _constants2.default.userPaymentType.QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_500:
          return 'Juggle St Pro - Agency Quarterly';
        case _constants2.default.userPaymentType.QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_750:
          return 'Juggle St Pro - Quarterly';
        case _constants2.default.userPaymentType.ANNUAL_BUSINESS_TIER1_SUBSCRIPTION_1500:
          return 'Juggle St Pro - Single Site Annual';
        case _constants2.default.userPaymentType.ANNUAL_BUSINESS_TIER2_SUBSCRIPTION_1500:
          return 'Juggle St Pro - Agency Annual';
        default:
          throw new Error("Unsupported option: " + paymentType);
      }
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      if (!date) return false;

      return _common2.default.formatDate(date);
    }
  }, {
    key: "hasPaymentsAdminAccess",
    value: function hasPaymentsAdminAccess() {
      var appContext = this.appContextService.getAppContext();
      if (!appContext) return false;

      if (this.appContextService.hasPaymentsAdminAccess(appContext.roles)) return true;else return false;
    }
  }, {
    key: "hasGlobalAdminAccess",
    value: function hasGlobalAdminAccess() {
      var appContext = this.appContextService.getAppContext();
      if (!appContext) return false;

      if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) return true;else return false;
    }
  }, {
    key: "cancelSubscription",
    value: function cancelSubscription() {
      var _this2 = this;

      if (confirm('Are you sure you want to cancel this subscription?')) {

        this.usersService.cancelSubscription(this.user.userId, this.user, function (response) {
          _this2.notificationService.success("Update Successful");
          _this2.user = response.data;
        }, function (error) {
          _this2.notificationService.error(error.data ? error.data : "Update Failed");
        });
      }
    }
  }]);
  return userPaymentDetailsController;
}();

exports.default = userPaymentDetailsController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-payment-details/user-payment-details.controller.js
 **/